import React from 'react';
import MintCount from "./mintCount";

const Header = () =>{



    return(
        <div className="top-header">
            <MintCount />
        </div>
    )
};

export default Header;